export default (data = {}) => ({
  required: false,
  disabled: false,
  show: () => true,
  render: true,
  transformIf: ({ value }) => ![undefined, null].includes(value),
  transform: ({ value }) => value,
  reverseTransform: ({ value }) => value,
  ...data,
});
